// HalfNote-specific header for the Sideblock layout.
// Uses DS UI components (@lib/ui, @lib/theme) throughout.
// Only non-DS dependency: Profile (which uses auth context for user data).
import clsx from 'clsx';

import { ThemeSwitcher, PresetSwitcher, useThemeContext } from '@lib/theme';
import { useBreakpointsContext } from '@/ds/contexts/breakpoint/context';
import { SidebarToggleBtn } from './SidebarToggleBtn';
import { Profile } from '../Profile';

export function Header() {
  const { xlAndUp } = useBreakpointsContext();
  const { cardSkin } = useThemeContext();

  return (
    <header
      className={clsx(
        'app-header transition-content dark:border-dark-600 sticky top-0 z-20 flex h-[65px] items-center gap-1 border-b border-gray-200 bg-white/80 px-(--margin-x) backdrop-blur-sm backdrop-saturate-150 max-sm:justify-between',
        cardSkin === 'bordered' ? 'dark:bg-dark-900/80' : 'dark:bg-dark-700/80'
      )}
    >
      {!xlAndUp && (
        <div className="xl:hidden">
          <SidebarToggleBtn />
        </div>
      )}

      <div className="flex flex-1 items-center justify-end gap-2">
        <PresetSwitcher />
        <ThemeSwitcher />
        <Profile />
      </div>
    </header>
  );
}
